import { FormattedMessage, IntlShape } from 'react-intl'
import styled from 'styled-components'

import MenuButton from '@/components/buttons/MenuButton'
import IglooIcon from '@/components/images/IglooIcon'
import MSSharepointIcon from '@/components/images/MSSharepointIcon'
import { ChannelConnection } from '@/pages/OrganizationChannelConnectionsPage/interfaces'

import messages from './messages'

interface ColumnsProps {
  onSelectChannel: (channelConnection: ChannelConnection) => void
  onDeleteChannel: (id: string) => void
  onFilterChange: ({ value, filter }: { value: string; filter: string }) => void
  setConfirmDelete: any
}
interface RowData {
  rowData: ChannelConnection
}

const StyledMenuButton = styled(MenuButton)`
  button {
    float: right;
  }
`

export default ({ intl, onDeleteChannel, setConfirmDelete, onSelectChannel }: ColumnsProps & { intl: IntlShape }) => [
  {
    property: 'name',
    header: {
      label: intl.formatMessage(messages.connection),
      sortable: true
    },
    cell: {
      transforms: [
        (_name: string, { rowData }: RowData) => ({
          index: rowData.id
        })
      ],
      formatters: [
        (name: string, { rowData }: RowData) => {
          let icon

          switch (rowData.type) {
            case 'microsoft': {
              icon = <MSSharepointIcon />
              break
            }
            case 'oidc': {
              icon = <IglooIcon />
              break
            }
            default:
            // no image
          }

          return (
            <button
              className="flex items-center whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0"
              onClick={() => onSelectChannel(rowData)}
            >
              <div className="h-11 w-11 flex-shrink-0">{icon}</div>
              <div className="ml-4">
                <div className="text-left font-bold text-gray-900">{rowData.name}</div>
                <div className="mt-1 text-left text-gray-500">{rowData.claimValueTenantId}</div>
              </div>
            </button>
          )
        }
      ]
    },
    props: {
      style: {
        maxWidth: 350
      }
    }
  },
  {
    property: 'id',
    cell: {
      transforms: [
        (_id: string, { rowData }: RowData) => ({
          index: rowData.id
        })
      ],
      formatters: [
        (id: string, { rowData }: RowData) => {
          const menuOptions = []

          menuOptions.push(
            <button
              key="delete"
              data-testid="delete-button"
              className="menu-item"
              onClick={() => {
                setConfirmDelete({
                  message: <FormattedMessage {...messages.confirmDelete} values={{ channelName: rowData.name }} />,
                  onConfirm: onDeleteChannel,
                  confirmMessage: <FormattedMessage {...messages.yes} />,
                  cancelMessage: <FormattedMessage {...messages.no} />,
                  isWarning: true,
                  id: rowData.id
                })
              }}
            >
              <FormattedMessage {...messages.deleteChannel} />
            </button>
          )
          return (
            <div data-testid="builder-button">
              <StyledMenuButton className="builder-menu-button">{menuOptions}</StyledMenuButton>
            </div>
          )
        }
      ]
    }
  }
]
